// SPDX-License-Identifier: AGPL-3.0-or-later

import {getExtendedDocument} from '@app/features/platform/types/Browser';

export function getVoiceCallFullscreenElement(): Element | null {
	const doc = getExtendedDocument();
	return (
		document.fullscreenElement ||
		doc.webkitFullscreenElement ||
		doc.mozFullScreenElement ||
		doc.msFullscreenElement ||
		null
	);
}

const listeners = new Set<() => void>();
const events = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];
const notify = (): void => {
	for (const listener of listeners) listener();
};

export function subscribeVoiceCallFullscreenChange(listener: () => void): () => void {
	if (listeners.size === 0) {
		for (const type of events) document.addEventListener(type, notify);
	}
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
		if (listeners.size === 0) {
			for (const type of events) document.removeEventListener(type, notify);
		}
	};
}
